<script setup>
import { CalendarDays } from "@lucide/vue";
defineProps({ modelValue: String, placeholder: String, min: String, max: String });
defineEmits(["update:modelValue", "change"]);
</script>
<template>
  <div class="relative">
    <CalendarDays class="pointer-events-none absolute left-3 top-3 size-4 text-slate-400" />
    <input
      type="date"
      class="input pl-9"
      :value="modelValue"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    />
  </div>
</template>

